import isNewReduxUtil from 'modules/redux/utils/is-new'
import { hasErrorReduxUtil } from 'modules/redux/utils/legacy/has-error'

/**
 * Checks if the address is invalid or not.
 * @param  {Address} address
 * @param  {DomainList} shipping
 * @returns {boolean}
 */
function isUnrecognizedAddressShippingUtil (address, shipping) {
  if (isNewReduxUtil(address)) {
    return false
  }
  return hasErrorReduxUtil(shipping.all)
}

export {
  isUnrecognizedAddressShippingUtil
}
